var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadDisableIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7188 14.5001L1.61457 14.5001C1.27361 14.5001 0.999385 14.7743 0.999385 15.1152C0.999385 15.4562 1.27361 15.7305 1.61457 15.7305L13.7188 15.7305C14.0598 15.7305 14.334 15.4562 14.334 15.1152C14.334 14.7743 14.0598 14.5001 13.7188 14.5001ZM11.9189 7.0948L8.48706 3.67773C8.24245 3.44054 7.85707 3.44054 7.61247 3.67773L4.1806 7.0948C3.93599 7.33941 3.94341 7.72483 4.1806 7.96202C4.4252 8.19921 4.81059 8.19921 5.05519 7.96202L7.43449 5.5901V11.9424C7.43449 12.2834 7.7088 12.5576 8.04976 12.5576C8.39072 12.5576 8.66494 12.2834 8.66494 11.9424V5.5901L11.0443 7.96202C11.2889 8.19921 11.6743 8.19921 11.9189 7.96202C12.1635 7.71742 12.1561 7.332 11.9189 7.0948Z",
    fill: "#949494"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadDisableIcon);
export default __webpack_public_path__ + "static/media/upload-disable-icon.420061a6fcc069ec472dece72311fe17.svg";
export { ForwardRef as ReactComponent };